<script>
import {AttachmentName} from "@/store/model/Attachment";
import {formatZonedDateTime} from "@/baseUtils";
import {mapActions} from "pinia";
import {documentStore} from "@/store/documentStore";
import BaseAvatar from "@/components/BaseAvatar/BaseAvatar.vue";
import i18n from "@/i18n";


export default {
  name: "ArgumentListItem",
  props: {
    itemData: {
      type: Object
    }
  },
  components: {
    BaseAvatar
  },
  data() {
    return {
      argumentText: '',
    }
  },
  computed: {
    argumentType() {
      return this.itemData.argumentDetailed.type;
    },
    videoArgPreview() {
      const attachments = this.itemData.argumentDetailed.attachments || [];
      let preview = attachments.filter((item) => {
        return item.name === AttachmentName.VIDEO_PREVIEW;
      })[0];

      return preview
          ? '/api/video/' + preview.hash + '/preview'
          : '/html/images/arguments/private-video.svg';
    },
    lastUpdateDate() {
      return formatZonedDateTime(this.itemData.dateTime);
    },
    itemDateLabel() {
      return this.itemData.version > 1 ? i18n.global.t('mainSearch.updated') : i18n.global.t('mainSearch.registered');
    },
  },
  methods: {
    ...mapActions(documentStore, [
      'getTextDocumentContent'
    ]),
    getArgumentContent() {
      const argContentId = this.itemData.argumentDetailed.contentId;
      if (this.argumentType === 'HTML_TEXT') {
        this.getTextDocumentContent(argContentId).then((documentText)=> {
          this.argumentText = documentText.data;
        });
      }
    },
    openArgumentConnectedEntity() {
      let routeData = null;

      if (this.itemData.proposalIssueNumber) {
        routeData = this.$router.resolve({ name: 'ProposalView', params: { id: this.itemData.proposalIssueNumber }});
      } else if (this.itemData.opinionNumber) {
        routeData = this.$router.resolve({ name: 'OpinionView', params: { id: this.itemData.opinionNumber }});
      }
      if (routeData) {
        window.open(routeData.href, '_blank');
      }
    }
  },
  beforeMount() {
    this.getArgumentContent();
  }
}
</script>

<template>
  <div class="argument-list-item">
    <div v-if="argumentType === 'VIDEO'"
         class="argument-thumbnail argument-thumbnail--video"
         @click="openArgumentConnectedEntity()"
    >
      <img :src="videoArgPreview" class="preview-img" alt="">
    </div>
    <div v-else-if="argumentType === 'HTML_TEXT'"
         class="argument-thumbnail argument-thumbnail--text"
         v-html="argumentText"
         @click="openArgumentConnectedEntity()"
    >
    </div>
    <div style="padding: 12px;">
      <span class="text text-link argument-title" @click="openArgumentConnectedEntity()">
        {{itemData.title}}
      </span>
      <div class="info-row">
      <span class="info-label">
        {{$t('mainSearch.argument.creator')}}
      </span>
        <span class="info-text">
        {{itemData.creator.name}}
      </span>
        <base-avatar :size="'SM'"
                     :img-hash="itemData.creator.largeImgHash"
        />
      </div>
      <div class="info-row">
        <span class="info-text">{{itemDateLabel}} {{lastUpdateDate}}</span>
      </div>
    </div>


  </div>
</template>

<style lang="scss" scoped>
.argument-list-item {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  position: relative;
  max-width: 600px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(79, 79, 79, .15);

  .argument-thumbnail {
    position: relative;
    width: 247px;
    min-width: 247px;
    height: 139px;
    background-image: linear-gradient(119deg, #bc5bff, #8e4eba 99%);
    cursor: pointer;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 45px;
      left: 98px;
      z-index: 1;
      min-width: 50px;
      height: 50px;
      background: url("~@/assets/img/proposal/video-play-btn-75.svg") center no-repeat;
      background-size: 100%;
    }
    &--text {
      width: 247px;
      height: 139px;
      overflow: hidden;
      padding: 10px 15px;
      color: #fff;
      background-image: linear-gradient(119deg, #bc5bff, #8e4eba 99%);
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      line-height: 1.6;
      letter-spacing: -.01px;
      word-break: break-all;
    }
    &--video {
      .preview-img {
        width: 247px;
        height: 139px;
      }
    }
  }

  .argument-title {
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    display: block;
    color: #7835a6
  }

  .info-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .info-label {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    color: #4f4f4f;
  }

  .info-text {
    display: inline-block;
    margin-right: 5px;
    font-size: 12px;
    color: #4f4f4f;
  }
}
</style>